export default "images/车灯开启情况-后雾灯指示灯.png";